import React from "react";
import { CheckIcon, FileDownIcon, InfoIcon, ShieldCheckIcon } from "lucide-react";
import { CheckoutButton } from "./CheckoutButton";
import { Accent, Container, SectionHeader } from "./ui";
import { bonuses, checkout, images, offerIncluded, productName } from "../data/content";
export function OfferDetails() {
  return <section id="offer-details" className="scroll-mt-0 bg-petrol-deep py-12 text-white md:py-24" data-id="element-102" data-mp="3ii2ze2bsi1lf">
      <Container data-id="element-103" data-mp="jxth4gjhw0wa">
        <SectionHeader tone="dark" eyebrow="Your complete kit" title={<>
              Your whole year, <Accent tone="dark" data-id="element-105" data-mp="a0oru7ucrpb9">planned in minutes</Accent>
            </>} data-id="element-104" data-mp="jycvjn9xs75k" />

        <div className="mx-auto max-w-[620px] rounded-2xl bg-white px-4 py-7 text-ink shadow-[0_24px_60px_rgba(0,0,0,0.25)] sm:px-10 sm:py-10" data-id="element-106" data-mp="5zn0ed6oghju">
          <div className="text-center" data-id="element-107" data-mp="2uryy41m2qdxl">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-petrol" data-id="element-108" data-mp="2uouq0t5hmy1n">Complete pack</p>
            <h3 className="mt-2 font-display text-[30px] font-extrabold uppercase leading-[0.95] text-petrol sm:text-[40px]" data-id="element-109" data-mp="37fnhkqtkygv5">
              {productName}
            </h3>
            <p className="mt-3 text-[15px] text-muted" data-id="element-110" data-mp="3cdyqmzc1wncb">1 activity book · 12-month calendar · 5 bonuses</p>
          </div>

          <div className="mt-6 rounded-xl bg-cream p-5" data-id="element-111" data-mp="32gkc559ou8mn">
            <img src={images.boxMockup} alt="The complete activity kit box set" className="mx-auto h-auto w-full max-w-[220px] rounded-lg sm:max-w-[260px]" data-id="element-112" data-mp="32f9c9gjd5l0t" />
          </div>

          <div className="mt-7 border-t border-line pt-7" data-id="element-113" data-mp="2thyudcc1ixmx">
            <p className="text-center text-xs font-semibold uppercase tracking-[0.16em] text-ink" data-id="element-114" data-mp="2es17czpukdzb">What’s included</p>
            <ul className="mt-5 grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-115" data-mp="2jqm2ikq8s7gw">
              {offerIncluded.map(item => <li key={item} className="flex items-start gap-3 font-medium text-ink" data-id="element-116" data-mp="25snvk0e93dbf">
                  <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sage" data-id="element-117" data-mp="2arhalx96rcdp">
                    <CheckIcon className="h-3.5 w-3.5 text-petrol" strokeWidth={3} aria-hidden="true" data-id="element-118" data-mp="bippmk758uel" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="mt-7 border-t border-line pt-7" data-id="element-119" data-mp="2iki8a1y9w0f">
            <p className="text-center text-xs font-semibold uppercase tracking-[0.16em] text-ink" data-id="element-120" data-mp="2fyb2biz1iiq">
              Plus 5 bonuses included
            </p>
            <ul className="mt-5 space-y-3" data-id="element-121" data-mp="ua0aajma0ay1">
              {bonuses.map((b, i) => <li key={b.title} className="flex items-center gap-4 rounded-xl border border-line bg-cream p-3" data-id="element-122" data-mp="q6khjydbuuqm" data-mpi={i}>
                  <img src={b.src} alt={`${b.title} cover`} loading="lazy" className="h-[76px] w-[76px] shrink-0 rounded-lg object-cover sm:h-[88px] sm:w-[88px]" data-id="element-123" data-mp="l7hay9hp8ggj" />
                  <div className="min-w-0" data-id="element-124" data-mp="1lgpgsj6qbeka">
                    <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-petrol" data-id="element-125" data-mp="1li0jefofug9t">
                      Bonus {String(i + 1).padStart(2, "0")}
                    </p>
                    <p className="mt-0.5 font-display text-lg font-bold uppercase leading-[1.05] text-ink sm:text-xl" data-id="element-126" data-mp="1ug2pvaqxy14h">
                      {b.title}
                    </p>
                    <p className="mt-1 hidden text-[13px] leading-snug text-muted sm:block" data-id="element-127" data-mp="247gl36bv0ert">{b.benefit}</p>
                  </div>
                </li>)}
            </ul>
          </div>

          <div className="mt-7 border-t border-line pt-7 text-center" data-id="element-128" data-mp="2e4l9lct6gmbs">
            <p className="flex items-end justify-center text-petrol" data-id="element-129" data-mp="2e3a6lf7k3ilq">
              <span className="mb-2 font-display text-[36px] font-extrabold leading-none sm:text-[40px]" data-id="element-130" data-mp="2i66iyo6i6ih8">$</span>
              <span className="font-display text-[88px] font-extrabold leading-[0.8] tracking-[-0.02em] sm:text-[104px]" data-id="element-131" data-mp="jswtv8f4gfqc">
                {checkout.price}
              </span>
              <span className="mb-1 ml-2 text-sm font-semibold text-ink" data-id="element-132" data-mp="3omldo7cd5epc">{checkout.currency}</span>
            </p>
            <p className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs font-semibold uppercase tracking-[0.16em] text-muted" data-id="element-133" data-mp="3km1j9bj6cp6w">
              <span data-id="element-134" data-mp="3tmhn4m3txyca">One-time payment</span>
              <span aria-hidden="true" data-id="element-135" data-mp="3tnso6e5w4rzp">·</span>
              <span data-id="element-136" data-mp="35x5b7eh4bc6a">No subscription</span>
            </p>
          </div>

          <div className="mt-7" data-id="element-137" data-mp="35v2de89q4er0">
            <CheckoutButton label="Get my complete kit" className="w-full" data-id="element-138" data-mp="30yu2j72k77pn" />
            <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-[13px] font-medium text-ink" data-id="element-139" data-mp="3fn85rj3w0y6q">
              <ShieldCheckIcon className="h-4 w-4 shrink-0 text-petrol" aria-hidden="true" data-id="element-140" data-mp="3avzu0gf350qe" />
              Backed by our 10-day money-back guarantee
            </p>
          </div>

          <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2 border-t border-line pt-6 text-[13px] font-medium text-muted" data-id="element-141" data-mp="2i7u8vsk4d9q1">
            <li className="flex items-center gap-1.5" data-id="element-142" data-mp="xoqplhu67sf6">
              <FileDownIcon className="h-4 w-4 text-petrol" aria-hidden="true" data-id="element-143" data-mp="12giabbqnb3xe" /> Downloadable PDFs
            </li>
            <li className="flex items-center gap-1.5" data-id="element-144" data-mp="opn98lme1r4d">
              <InfoIcon className="h-4 w-4 text-petrol" aria-hidden="true" data-id="element-145" data-mp="oqy94acpqeq7" /> Payment & delivery details at checkout
            </li>
          </ul>
        </div>

        <p className="mx-auto mt-6 max-w-[580px] text-center text-[13px] text-white/75" data-id="element-146" data-mp="1gg1ddq4lnp2u">
          Price shown in {checkout.currency}. Digital product in English — no physical books are shipped.
        </p>
      </Container>
    </section>;
}